import state from './state.js'

export default {
    namespaced: true,
    state,
}